exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{\n    background:rgb(43, 43, 43) !important;\n}\n\n.h3_message{\n    margin-bottom:10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/components/configure/configure.component.css
// module id = ../../../../../src/app/components/configure/configure.component.css
// module chunks = main